import script from "./TextInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=5ac04b02&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac04b02"]])

export default __exports__